/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
/**
 * Non-blocking employee advisory category.
 */
export enum EmployeeExecutionAdvisoryCategory {
    MESSAGE_FIDELITY_REVIEW = 'message-fidelity-review',
}
